import Send from '../send';

const DEFAULT_API = '/v1/visit-info';
export default {

    ///visitor-list
    getVisitorInfoList(hostInfoSeq) {
        return Send({
            url : `${DEFAULT_API}/visitor-list`,
            method : 'GET',
            params : {
                hostInfoSeq : hostInfoSeq
            }
        });
    },

    getVisitorInfoListByPage(hostInfoSeq, pageNumber) {
        return Send({
            url : `${DEFAULT_API}/visitor-list?page=${pageNumber}`,
            method : 'GET',
            params : {
                hostInfoSeq : hostInfoSeq
            }
        });
    },

    getVisitorInfoListBySearchAndPage(hostInfoSeq, searchInfo, pageNumber) {
        return Send({
            url : `${DEFAULT_API}/visitor-list?page=${pageNumber}`,
            method : 'GET',
            params : {
                hostInfoSeq : hostInfoSeq,
                searchToDate : searchInfo.searchToDate,
                searchFromDate : searchInfo.searchFromDate,
                searchValue : searchInfo.searchValue,
                visitorInfoSearchType : searchInfo.visitorInfoSearchType,
                siteInfoSeq : searchInfo.siteInfoSeq
            }
        });
    },

    ///visitor-list
    getVisitorHistoryInfoList(visitorInfoSeq) {
        return Send({
            url : `${DEFAULT_API}/visitor-list/history`,
            method : 'GET',
            params : {
                visitorInfoSeq : visitorInfoSeq
            }
        });
    },

    ///visitor-list
    getVisitorApproveInfoList(hostInfoSeq) {
        return Send({
            url : `${DEFAULT_API}/visitor-list/approve`,
            method : 'GET',
            params : {
                hostInfoSeq : hostInfoSeq
            }
        });
    },

    //visitor-certificate-list
    getVisitorCertificateInfoList(hostInfoSeq, siteInfoSeq) {
        return Send({
            url : `${DEFAULT_API}/visitor-list/certificate`,
            method : 'GET',
            params : {
                hostInfoSeq : hostInfoSeq,
                siteInfoSeq : siteInfoSeq
            }
        })
    },

    getVisitorApproveInfoListByPage(hostInfoSeq, pageNumber) {
        return Send({
            url : `${DEFAULT_API}/visitor-list/approve?page=${pageNumber}`,
            method : 'GET',
            params : {
                hostInfoSeq : hostInfoSeq
            }
        });
    },

    getVisitorApproveInfoListBySearchAndPage(hostInfoSeq, searchInfo, pageNumber) {
        return Send({
            url : `${DEFAULT_API}/visitor-list/approve?page=${pageNumber}`,
            method : 'GET',
            params : {
                hostInfoSeq : hostInfoSeq,
                searchToDate : searchInfo.searchToDate,
                searchFromDate : searchInfo.searchFromDate,
                searchValue : searchInfo.searchValue,
                visitorInfoSearchType : searchInfo.visitorInfoSearchType,
                siteInfoSeq : searchInfo.siteInfoSeq
            }
        });
    },

    getVisitorCertificateInfoListBySearchAndPage(hostInfoSeq, siteInfoSeq, searchInfo, pageNumber) {
        return Send({
            url : `${DEFAULT_API}/visitor-list/certificate?page=${pageNumber}`,
            method : 'GET',
            params : {
                hostInfoSeq : hostInfoSeq,
                siteInfoSeq : siteInfoSeq,
                searchToDate : searchInfo.searchToDate,
                searchFromDate : searchInfo.searchFromDate,
                searchValue : searchInfo.searchValue,
                visitorInfoSearchType : searchInfo.visitorInfoSearchType
            }
        });
    },

    getVisitorInOutInfoList(hostInfoSeq) {
        return Send({
            url : `${DEFAULT_API}/visitor-list/in-out`,
            method : 'GET',
            params : {
                hostInfoSeq : hostInfoSeq
            }
        });
    },

    getVisitorInOutInfoListByPage(hostInfoSeq, pageNumber) {
        return Send({
            url : `${DEFAULT_API}/visitor-list/in-out?page=${pageNumber}`,
            method : 'GET',
            params : {
                hostInfoSeq : hostInfoSeq
            }
        });
    },

    getVisitorInOutInfoListBySearchPage(hostInfoSeq, searchInfo, pageNumber) {
        return Send({
            url : `${DEFAULT_API}/visitor-list/in-out?page=${pageNumber}`,
            method : 'GET',
            params : {
                hostInfoSeq : hostInfoSeq,
                searchToDate : searchInfo.searchToDate,
                searchFromDate : searchInfo.searchFromDate,
                searchValue : searchInfo.searchValue,
                visitorInfoSearchType : searchInfo.visitorInfoSearchType,
                siteInfoSeq : searchInfo.siteInfoSeq
            }
        });
    },


    getVisitorInfo(visitorInfoSeq) {
        return Send({
            url : `${DEFAULT_API}`,
            method : 'GET',
            params : {
                visitorInfoSeq : visitorInfoSeq
            }
        });
    },

    getVisitorInfo2(visitorInfoSeq) {
        return Send({
            url : `${DEFAULT_API}/2`,
            method : 'GET',
            params : {
                visitorInfoSeq : visitorInfoSeq
            }
        });
    },

    createVisitInfo(visitorApplicationInfo, visitorInfos) {
        let dto = {
            visitorApplicationInfo : visitorApplicationInfo,
            visitorInfos : visitorInfos
        };
        return Send({
            url : `${DEFAULT_API}`,
            method : 'POST',
            data : dto
        });
    },

    // /change-status
    visitorInfoChangeStatus(visitorInfoSeq, visitorStatus) {
        let visitorStatusDTO = {seq : visitorInfoSeq, visitorStatus : visitorStatus}
        return Send({
            url : `${DEFAULT_API}/change-status`,
            method : 'PUT',
            data : visitorStatusDTO
        });
    },

    visitorEducationClear(visitorInfoSeq) {
        return Send({
            url : `${DEFAULT_API}/education`,
            method : 'POST',
            data : visitorInfoSeq
        });
    },


    visitorPledge(visitorInfoSeq, type) {
        return Send({
            url : `${DEFAULT_API}/pledge/${type}`,
            method : 'POST',
            data : visitorInfoSeq
        });
    },

    findVisitor(name, phone) {
        return Send({
            url : `${DEFAULT_API}/find`,
            method : 'GET',
            params : {
                name : name,
                phone : phone
            }
        });
    }
    ,

    createVisitorTerms(visitorInfoSeq, termsInfos) {
        return Send({
            url : `${DEFAULT_API}/terms`,
            method : 'POST',
            data : {
                visitorInfoSeq : visitorInfoSeq,
                visitorTermsInfos : termsInfos
            }
        });
    },

    visitorQrCodeReSend(visitorInfoSeq) {
        return Send({
            url : `${DEFAULT_API}/qrReSend`,
            method : 'POST',
            params : {
                visitorInfoSeq : visitorInfoSeq
            }
        });
    },

    getDayilyVisitorInfo(siteInfoSeq) {
        return Send({
            url : `${DEFAULT_API}/getDayilyVisitorInfo/${siteInfoSeq}`,
            method : 'GET'
        });
    },

    getVisitorChartInfo(siteInfoSeq) {
        return Send({
            url : `${DEFAULT_API}/getVisitorChartInfo/${siteInfoSeq}`,
            method : 'GET'
        });
    },

    visitorCertificateSend(visitorInfoSeq) {
        return Send({
            url : `${DEFAULT_API}/certificateSend`,
            method : 'POST',
            params : {
                visitorInfoSeq : visitorInfoSeq
            }
        });
    },

    visitorCertificateRemind(visitorInfoSeq) {
        return Send({
            url : `${DEFAULT_API}/certificateRemind`,
            method : 'POST',
            params : {
                visitorInfoSeq: visitorInfoSeq
            }
        });
    },

    getUnreturnedVisitorList() {
        return Send({
            url: `${DEFAULT_API}/unreturned-list`,
            method: 'GET',
        })
    },

    getUnreturnedVisitorListBySearchAndPage(searchInfo, pageNumber) {
        return Send({
            url: `${DEFAULT_API}/unreturned-list?page=${pageNumber}`,
            method: 'GET',
            params : {
                searchToDate : searchInfo.searchToDate,
                searchFromDate : searchInfo.searchFromDate,
                searchValue : searchInfo.searchValue,
                visitorInfoSearchType : searchInfo.visitorInfoSearchType
            }
        })
    }
}
